import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Filter } from "lucide-react";
import { useTasksFilter } from "@/contexts/TasksFilterContext";

export const TasksFilter = () => {
  const { t } = useTranslation();
  const { statusFilter, setStatusFilter, priorityFilter, setPriorityFilter } = useTasksFilter();

  const statusOptions = [
    { value: "todo", label: t("tasks.status.todo", "To Do") },
    { value: "inProgress", label: t("tasks.status.inProgress", "In Progress") },
    { value: "done", label: t("tasks.status.done", "Done") }
  ];

  const priorityOptions = [
    { value: "low", label: t("tasks.priority.low", "Low") },
    { value: "medium", label: t("tasks.priority.medium", "Medium") },
    { value: "high", label: t("tasks.priority.high", "High") },
    { value: "urgent", label: t("tasks.priority.urgent", "Urgent") }
  ];

  const handleStatusChange = (value: string, checked: boolean) => {
    if (checked) {
      setStatusFilter([...statusFilter, value]);
    } else {
      setStatusFilter(statusFilter.filter(s => s !== value));
    }
  };

  const handlePriorityChange = (value: string, checked: boolean) => {
    if (checked) {
      setPriorityFilter([...priorityFilter, value]);
    } else {
      setPriorityFilter(priorityFilter.filter(p => p !== value));
    }
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline">
          <Filter className="h-4 w-4 mr-2" />
          {t("common.filter", "Filter")}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80" align="end">
        <div className="space-y-4">
          <div>
            <h4 className="font-medium mb-2">{t("tasks.list.status", "Status")}</h4>
            <div className="space-y-2">
              {statusOptions.map((option) => (
                <div key={option.value} className="flex items-center space-x-2">
                  <Checkbox
                    id={`status-${option.value}`}
                    checked={statusFilter.includes(option.value)}
                    onCheckedChange={(checked) => handleStatusChange(option.value, checked as boolean)}
                  />
                  <label htmlFor={`status-${option.value}`} className="text-sm">
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
          
          <div>
            <h4 className="font-medium mb-2">{t("tasks.list.priority", "Priority")}</h4>
            <div className="space-y-2">
              {priorityOptions.map((option) => (
                <div key={option.value} className="flex items-center space-x-2">
                  <Checkbox
                    id={`priority-${option.value}`}
                    checked={priorityFilter.includes(option.value)}
                    onCheckedChange={(checked) => handlePriorityChange(option.value, checked as boolean)}
                  />
                  <label htmlFor={`priority-${option.value}`} className="text-sm">
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};
